import {
    Create,
    SimpleForm,
    TextInput,
    NumberInput,
    required,
    AutocompleteInput,
    useDataProvider,
    FormDataConsumer,
    minValue,
} from 'react-admin';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

interface Item {
    id: string;
    name: string;
    subjectId?: string;
}
const MetaDataCreate = () => {
    const dataProvider = useDataProvider();
    const location = useLocation();
    const resource = location.pathname.split('/')[1];

    const [subjects, setSubjects] = useState<Item[]>([]);
    const [chapters, setChapters] = useState<Item[]>([]);

    useEffect(() => {
        if (resource === 'master-chapters' || resource === 'master-topics') {
            dataProvider
                .getList<Item>('master-subjects', {
                    pagination: { page: 1, perPage: 100 },
                    sort: { field: 'name', order: 'ASC' },
                    filter: {},
                })
                .then(({ data }) => setSubjects(data))
                .catch(err => console.error('Error fetching subjects:', err));
        }
    }, [dataProvider, resource]);

    useEffect(() => {
        if (resource === 'master-topics') {
            dataProvider
                .getList<Item>('master-chapters', {
                    pagination: { page: 1, perPage: 100 },
                    sort: { field: 'name', order: 'ASC' },
                    filter: {},
                })
                .then(({ data }) => setChapters(data))
                .catch(err => console.error('Error fetching chapters:', err));
        }
    }, [dataProvider, resource]);

    return (
        <Create redirect="list">
            <SimpleForm>
                <TextInput
                    source="name"
                    label="Name"
                    validate={[required(), validateNotEmpty]}
                    fullWidth
                />

                {resource === 'master-chapters' && (
                    <AutocompleteInput
                        source="subjectId"
                        label="Subject"
                        choices={subjects}
                        optionText="name"
                        optionValue="id"
                        fullWidth
                        validate={[required()]}
                    />
                )}

                {resource === 'master-topics' && (
                    <>
                        <AutocompleteInput
                            source="subjectId"
                            label="Subject"
                            choices={subjects}
                            optionText="name"
                            optionValue="id"
                            fullWidth
                            validate={[required()]}
                        />

                        <FormDataConsumer>
                            {({ formData, ...rest }) => {
                                const selectedSubject = formData.subjectId;
                                const filteredChapters = chapters.filter(
                                    chapter => chapter.subjectId === selectedSubject,
                                );
                                return (
                                    <AutocompleteInput
                                        source="chapterId"
                                        label="Chapter"
                                        choices={filteredChapters}
                                        optionText="name"
                                        optionValue="id"
                                        fullWidth
                                        validate={[required()]}
                                        disabled={!selectedSubject}
                                        helperText={
                                            !selectedSubject
                                                ? 'Select a subject first'
                                                : filteredChapters.length === 0
                                                ? 'No chapters available for this subject'
                                                : ''
                                        }
                                        {...rest}
                                    />
                                );
                            }}
                        </FormDataConsumer>
                    </>
                )}

                <NumberInput
                    source="displayOrder"
                    label="Display Order"
                    defaultValue={0}
                    fullWidth
                    helperText="Optional: Enter a number for ordering (default: 0)"
                    validate={[required(),minValue(1)]}
                />
            </SimpleForm>
        </Create>
    );
};

export default MetaDataCreate;
